import gql from "graphql-tag";

export const GET_PROMOS = {
    id: "GET_PROMOS",
    query: gql`
        query GET_PROMOS($hotelRef: ID!, $filter: PromosFilter!, $page: Int, $size: Int, $orderBy: OrderBy) {
            getPromos(hotelRef: $hotelRef, filter: $filter, page: $page, size: $size, orderBy: $orderBy) {
                results {
                    id
                    name
                    available
                    expired
                    isDefault
                    ongoing
                    screensNum
                    screenIDs

                    promoContents {
                        id
                        name
                        contentDuration
                        contentImages
                        contentNavigation
                        promoIDs
                        promosNum
                        scheduleDailyType
                        scheduleDaysType
                        scheduleDaysOfWeek
                        scheduleStart
                        scheduleEnd
                        timeRanges {
                            startTime
                            endTime
                        }
                    }
                }
            }
        }
    `,
    defaultVars: { page: 1, size: 1000 },
};
